import * as React from 'react';

/**
 * @param {Object} serviceTag
 * @param {Function} onChange
 * @param {boolean} isChecked
 * @param {Object} counts
 * @return {React.JSX.Element}
 * @constructor
 */
export const ServiceBlock = ({ serviceTag, onChange, isChecked, counts }) => {
  return (
    <div
      className='mdc-form-field filter-row__check'
      onClick={() => {
        $(`.input_campServiceTags${serviceTag.main_id}`).trigger('click');
      }}
    >
      <div className='mdc-checkbox'>
        <input
          className={`mdc-checkbox__native-control input_campServiceTags${serviceTag.main_id}`}
          type='checkbox'
          onClick={(event) => {
            event.stopPropagation();
          }}
          onChange={onChange}
          value={serviceTag.id}
          checked={isChecked}
          data-id={serviceTag.id}
        />

        <div className='mdc-checkbox__background'>
          <svg className='mdc-checkbox__checkmark' viewBox='0 0 24 24'>
            <path className='mdc-checkbox__checkmark-path' fill='none' d='M1.73,12.91 8.1,19.28 22.79,4.59' />
          </svg>

          <div className='mdc-checkbox__mixedmark' />
        </div>
      </div>

      <label className='mdc-checkbox__label'>
        {serviceTag.name}&nbsp;&nbsp;
        {counts && !isChecked && (
          <span className={'mdc-checkbox__label-count'}>{counts[serviceTag.id] ?? 0}</span>
        )}
      </label>
    </div>
  );
}
